<script setup lang="ts">

</script>

<template>
  <div class="footer">
    <collection-footer-connection />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.footer
  @apply pointer-events-none w-full h-[#{$nav-h-default}] absolute bottom-0 left-0 right-0 flex justify-center pb-[#{$nav-gap-pills}] items-center
</style>
